import { Row, Tabs } from 'antd';
import { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';
import styled from 'styled-components';

export const ParkContainer = styled(Row)`
  background-color: #ffffff;
  border-radius: 20px;
`;

export const ShowContainer = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 20px 20px 0px;
`;

export const Title = styled.h3`
  margin: 0;
  padding: 0;
  font-weight: 700;
  font-size: 18px;
  color: #000000;
`;

export const Text = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
`;

export const DateRangePickerContainer = styled.div`
  background: #ffffff;
  border-radius: 10px;
  height: 45px;
  border: none;
  border: 1px solid #d9d9d9;
  
  @media (max-width: ${DESKTOP_WIDTH}px) {
    height: 41px;
    width: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px var(--color-4);
  }
  .react-datepicker__header {
    text-align: center;
    background-color: #f0f0f0;
    border-top-left-radius: 0.3rem;
    padding: 8px 0;
    position: relative;
    border-bottom: none;
  }
  input {
    width: 306px;
    border: none;
    outline: none;
  }
  i {
    pointer-events: none;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 6px 6px 0;
  }
  .react-datepicker__header {
    background: #fff;
  }
  .react-datepicker__portal > div {
    padding: 16px;
    border-radius: 12px;
  }
  .react-datepicker__portal {
    background: rgb(0 0 0 / 50%);
  }
  .react-datepicker__month-container {
    background: #fff;
    .react-datepicker__day.react-datepicker__day--keyboard-selected {
      background-color: inherit;
      color: inherit;
      font-weight: inherit;
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected- {
      background-color: inherit;
      color: inherit;
      font-weight: inherit;
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range {
      background: #fef2f1;
      color: #e92127;
      border-radius: 50%;
      &:hover {
        background: #fef2f1;
        color: #e92127;
      }
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range {
      background: #fef2f1;
      color: #e92127;
      border-radius: 50%;
      &:hover {
        background: #fef2f1;
        color: #e92127;
      }
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range {
      background: #fef2f1;
      color: #e92127;
      border-radius: 50%;
      &:hover {
        background: #fef2f1;
        color: #e92127;
      }
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range.react-datepicker__day--selecting-range-start {
      background: #e92127 !important;
      color: #ffffff !important;
      border-radius: 50%;
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
      background: #e92127 !important;
      color: #ffffff !important;
      border-radius: 50%;
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end {
      background: #e92127 !important;
      color: #ffffff !important;
      border-radius: 50%;
    }
    .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range.react-datepicker__day--selecting-range-end {
      background: #e92127 !important;
      color: #ffffff !important;
      border-radius: 50%;
    }
  }
  .react-datepicker__day--range-end {
    background: #e92127 !important;
    color: #ffffff !important;
    border-radius: 50%;
  }
  .react-datepicker__day--range-start {
    background: #e92127 !important;
    color: #ffffff !important;
    border-radius: 50%;
  }
  .react-datepicker-popper {
    padding: 16px;
    background: var(--color-5);
    border-radius: 12px;
  }
  .react-datepicker__month,
  .react-datepicker {
    font-family: var(--font-body);
  }
  .react-datepicker__navigation--next {
    right: 10px;
  }
  .react-datepicker__navigation--previous {
    left: 10px;
  }
  .react-datepicker__week {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background: #e92127;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
  }
  .react-datepicker__day--today {
    font-weight: 400;
  }
  .react-datepicker__navigation {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    top: 16px;
    flex: 0 0 auto;
    background: #ffffff;
    border: 1px solid #e92127;
  }
  .react-datepicker__navigation-icon--next::before {
    top: 55%;
    transform: translate(0, -50%) rotate(45deg);
    left: -3px;
    width: 8px;
    border-color: #e92127;
    height: 8px;
  }
  .react-datepicker__navigation-icon--previous::before {
    right: -3px;
    border-color: #e92127;
    transform: translate(0, -50%) rotate(225deg);
    top: 55%;
    width: 8px;
    height: 8px;
  }
  .react-datepicker__day--in-range {
    background: #fef2f1;
    color: #e92127;
    border-radius: 50%;
    &:hover {
      background: #fef2f1;
      color: #e92127;
    }
  }
  .react-datepicker__day--in-selecting-range {
    background: #fef2f1 !important;
    border-radius: 50% !important;
    color: #e92127;
    &:hover {
      background: #fef2f1 !important;
      border-radius: 50% !important;
      color: #e92127 !important;
    }
  }
  .react-datepicker__day {
    border-radius: 50%;
    transition: all 0.15s ease;
    &:hover {
      background: #e92127;
      border-radius: 50%;
      color: #fff;
    }
    &.react-datepicker__day--selected {
      background: #e92127 !important;
      color: #ffffff !important;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
  }
  .react-datepicker__day-names {
    display: flex;
  }
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .react-datepic_daker_y:hover {
    border-radius: 50%;
  }
  .react-datepicker__triangle {
    &::after,
    &::before {
      display: none;
    }
  }
  .react-datepicker {
    padding: 12px;
    border-radius: 20px;
    padding: 38px 40px;
  }
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    &:before {
      border-bottom: none;
    }
    @media (max-width: ${DESKTOP_WIDTH}px) {
      display: none;
    }
  }
  .ant-tabs-tab {
    padding: 6px 0px;
    & + .ant-tabs-tab {
      margin: 0 0 0 24px;
    }
    .ant-tabs-tab-btn {
      color: #808080;
      font-weight: 600;
    }
    &.ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: #000000;
      }
    }
  }
  .ant-tabs-ink-bar {
    background: #e92127;
  }
`;
